<script lang="ts">
  let { block } = $props();
  import { assets } from '$app/paths';
  import { PhotoPack } from '@reuters-graphics/graphics-components';
</script>

<PhotoPack
  id={block.id}
  class={block.class}
  width={block.width}
  textWidth={block.textWidth}
  gap={Number(block.gap)}
  images={block.images.map((img) => ({
    ...img,
    src: `${assets}/${img.src}`,
  }))}
  layouts={[
    {
      breakpoint: 450,
      rows: [2, 2],
    },
  ]}
/>
